__turbopack_context__.v({
  "currency": "voU37q_currency",
  "flag": "voU37q_flag",
  "locationButton": "voU37q_locationButton",
});
